// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pdf-container {
  height: 50rem;
}

.pdf-body {
  height: 90%;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInVzZWdlLWNvbmRpdGlvbi1kaWFsb2cuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLGFBQWE7QUFDZjs7QUFFQTtFQUNFLFdBQVc7QUFDYiIsImZpbGUiOiJ1c2VnZS1jb25kaXRpb24tZGlhbG9nLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucGRmLWNvbnRhaW5lciB7XG4gIGhlaWdodDogNTByZW07XG59XG5cbi5wZGYtYm9keSB7XG4gIGhlaWdodDogOTAlO1xufVxuIl19 */`, "",{"version":3,"sources":["webpack://./src/app/core/components/dialog/usege-condition-dialog/usege-condition-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA,4ZAA4Z","sourcesContent":[".pdf-container {\n  height: 50rem;\n}\n\n.pdf-body {\n  height: 90%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
